// extracted by mini-css-extract-plugin
export default {"container":"adminDownloadTutors_container__qbxOk"};